<template>
  <div v-if="isLoading" class="bg-black">
  </div>
  <div v-else-if="this.outageBannerExist">
    <div class="outage_alert" :style="outageBannerColor" @click="showOutageDetails">  
      <div class="container">
        <span v-if="this.outages.length > 1">
          <font-awesome-icon
          @click.stop=" handleNavigation(CONSTANTS.LEFT_NAVIGATION)"
          class="chevron-left-icon fa-lg"
          :icon="['fas', 'chevron-left']"
          :key="index"
        />
        </span> 
        <span>
        <img v-if="!this.outageColor.includes(CONSTANTS.OUTAGE_BANNER_GREEN)" :src="outageIcon" alt :style="imageBackgroundStyle" class="mr-2">
        {{ this.outageTitle }}
        </span>
        <span v-if="this.outages.length > 1">
          <font-awesome-icon
          @click.stop="handleNavigation(CONSTANTS.RIGHT_NAVIGATION)"
          class="chevron-right-icon fa-lg"
          :icon="['fas', 'chevron-right']"
          :key="index"
        />
        </span>  
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import OutageBannerModal from "./OutageBannerModal";
import outageIcon from "@/assets/outage_icon.png";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import * as CONSTANTS from '../../store/constants'
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

library.add({ faChevronRight, faChevronLeft });

export default {
  name: "outage-banner-card",
  mixins: [HomebaseMixpanelMixin],
  components: {OutageBannerModal},
  data() {
    return {
      CONSTANTS,
      outageTitle: null,
      outageColor: null,
      outageMessage: null,
      outageBannerExist: false,
      isLoading: false,
      hyperlink: null,
      outageIcon,
      outages: null,
      index: 0
    };
  },
  created() {
    this.initializeOutageBannerCard();
  },
  computed: {
    outageBannerColor() {
      if (this.outageColor) {
        if (this.outageColor.includes(CONSTANTS.OUTAGE_BANNER_YELLOW)) {
          return {'background-color': '#ffc21a', 'color': '#000'}
        } else if (this.outageColor.includes(CONSTANTS.OUTAGE_BANNER_GREEN)) {
          return {'background-color': '#2bc275', 'color': '#000'}
        } else if (this.outageColor.includes(CONSTANTS.OUTAGE_BANNER_RED)) {
          return {'background-color': '#d74e26', 'color': '#FFF'}
        }
      }
    },
    imageBackgroundStyle() {
      return this.outageColor && this.outageColor.includes(CONSTANTS.OUTAGE_BANNER_RED) ? {'filter': 'brightness(0) invert(1)', 'width' : '22px'} : {'filter': 'brightness(1) invert(0)', 'width' : '22px'};
    },
  },
  methods: {
    showOutageDetails() {
      let subEvent = `${this.outageTitle}`
      this.trackOutageAnnouncement(subEvent);
      let outageMessage = this.outageMessage
      let outageTitle = this.outageTitle

      if(this.hyperlink) {
        window.open(this.hyperlink, "_blank")
      } else {
        this.$modal.show(
            OutageBannerModal,
            {
              outageTitle,
              outageMessage
            },
            {
              adaptive: true,
              scrollable: true,
              maxWidth: 900,
              height: "auto",
            },
        )
      }
    },
    async initializeOutageBannerCard() {
      this.isLoading = true;
      let outageBannerResponse = await api.getOutageBannerInfo();
      if (outageBannerResponse) {
        const todayDate = moment(new Date()).utc().format('YYYY-MM-DD');
        const unexpiredOutageBanners = outageBannerResponse.value.filter(outage => {
          const expiryDate = moment(outage.fields.Expires).utc().format('YYYY-MM-DD');
          return moment(expiryDate).isSameOrAfter(todayDate)
        })
        let response = unexpiredOutageBanners;  
        this.outages = response;
      
        if (unexpiredOutageBanners.length > 0) {
          this.outageBannerExist = true;  
          this.handleOutageDisplay();
          this.handleScrollevent();
        }
      }
      this.isLoading = false;
    },

    handleScrollevent(){
      if(this.outages.length>1){   
        /*Outages scrolling at interval*/ 
        this.timeout= setInterval(() => {
          this.index++;
          this.index = this.index % this.outages.length;
          this.handleOutageDisplay();
        }, 10000); 
      }
      
    },

    handleNavigation(direction){
      this.isLoading = true;
      var totalOutages = this.outages.length;
      this.outageBannerExist = true;

      if(direction === CONSTANTS.LEFT_NAVIGATION) {
         /*Calculating the index when clicked on left navigation*/ 
        this.index = (this.index - 1+ totalOutages)% totalOutages;  
        this.handleOutageDisplay();
        clearInterval(this.timeout);
        this.handleScrollevent();
      }
      else if(direction === CONSTANTS.RIGHT_NAVIGATION) {
         /*Calculating the index when clicked on right navigation*/ 
        this.index = (this.index + 1)% totalOutages;
        this.handleOutageDisplay();
        clearInterval(this.timeout);
        this.handleScrollevent();
      } 
      this.isLoading= false;  
    },

    handleOutageDisplay(){
      this.outageTitle = this.outages[this.index].fields.Title
      this.outageColor = this.outages[this.index].fields.Color
      this.outageMessage = this.outages[this.index].fields.Body
      if(this.outages[this.index].fields.Hyperlink) {
        this.hyperlink = this.outages[this.index].fields.Hyperlink.Url
      }
      else{
        this.hyperlink = null;
      }
    }

  },
};
</script>

<style scoped>
.outage_alert {
  cursor: pointer;
  font-family: artifaktElementRegular !important;
  font-size: 16px;
  font-weight: 200;
  color: #000000;
  text-align: left;
  width: 100%;
  padding: 14px 0px 12px;
}

.bg-black {
  background: #000;
}

.chevron-left-icon{
  float:left;
  margin:2px 20px 0 0;
  cursor: pointer;
  opacity: 0.75;
}

.chevron-right-icon{
  float:right;
  margin-top: 2px;
  cursor: pointer;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/OutageBannerCard.vue